var _classCallCheck = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _get = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _inherits = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Generated by CoffeeScript 2.4.1
(function () {
  var NodeType,
    WriterState,
    XMLStreamWriter,
    XMLWriterBase,
    hasProp = {}.hasOwnProperty;
  NodeType = require('./NodeType');
  XMLWriterBase = require('./XMLWriterBase');
  WriterState = require('./WriterState');

  // Prints XML nodes to a stream
  module.exports = XMLStreamWriter = /*#__PURE__*/function (_XMLWriterBase) {
    "use strict";

    _inherits(XMLStreamWriter, _XMLWriterBase);
    var _super = _createSuper(XMLStreamWriter);
    // Initializes a new instance of `XMLStreamWriter`

    // `stream` output stream
    // `options.pretty` pretty prints the result
    // `options.indent` indentation string
    // `options.newline` newline sequence
    // `options.offset` a fixed number of indentations to add to every line
    // `options.allowEmpty` do not self close empty element tags
    // 'options.dontPrettyTextNodes' if any text is present in node, don't indent or LF
    // `options.spaceBeforeSlash` add a space before the closing slash of empty elements
    function XMLStreamWriter(stream, options) {
      var _this;
      _classCallCheck(this, XMLStreamWriter);
      _this = _super.call(this, options);
      _this.stream = stream;
      return _this;
    }
    _createClass(XMLStreamWriter, [{
      key: "endline",
      value: function endline(node, options, level) {
        if (node.isLastRootNode && options.state === WriterState.CloseTag) {
          return '';
        } else {
          return _get(_getPrototypeOf(XMLStreamWriter.prototype), "endline", this).call(this, node, options, level);
        }
      }
    }, {
      key: "document",
      value: function document(doc, options) {
        var child, i, j, k, len1, len2, ref, ref1, results;
        ref = doc.children;
        // set a flag so that we don't insert a newline after the last root level node 
        for (i = j = 0, len1 = ref.length; j < len1; i = ++j) {
          child = ref[i];
          child.isLastRootNode = i === doc.children.length - 1;
        }
        options = this.filterOptions(options);
        ref1 = doc.children;
        results = [];
        for (k = 0, len2 = ref1.length; k < len2; k++) {
          child = ref1[k];
          results.push(this.writeChildNode(child, options, 0));
        }
        return results;
      }
    }, {
      key: "cdata",
      value: function cdata(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "cdata", this).call(this, node, options, level));
      }
    }, {
      key: "comment",
      value: function comment(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "comment", this).call(this, node, options, level));
      }
    }, {
      key: "declaration",
      value: function declaration(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "declaration", this).call(this, node, options, level));
      }
    }, {
      key: "docType",
      value: function docType(node, options, level) {
        var child, j, len1, ref;
        level || (level = 0);
        this.openNode(node, options, level);
        options.state = WriterState.OpenTag;
        this.stream.write(this.indent(node, options, level));
        this.stream.write('<!DOCTYPE ' + node.root().name);
        // external identifier
        if (node.pubID && node.sysID) {
          this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
        } else if (node.sysID) {
          this.stream.write(' SYSTEM "' + node.sysID + '"');
        }
        // internal subset
        if (node.children.length > 0) {
          this.stream.write(' [');
          this.stream.write(this.endline(node, options, level));
          options.state = WriterState.InsideTag;
          ref = node.children;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            child = ref[j];
            this.writeChildNode(child, options, level + 1);
          }
          options.state = WriterState.CloseTag;
          this.stream.write(']');
        }
        // close tag
        options.state = WriterState.CloseTag;
        this.stream.write(options.spaceBeforeSlash + '>');
        this.stream.write(this.endline(node, options, level));
        options.state = WriterState.None;
        return this.closeNode(node, options, level);
      }
    }, {
      key: "element",
      value: function element(node, options, level) {
        var att, attLen, child, childNodeCount, firstChildNode, j, len, len1, name, prettySuppressed, r, ratt, ref, ref1, ref2, rline;
        level || (level = 0);
        // open tag
        this.openNode(node, options, level);
        options.state = WriterState.OpenTag;
        r = this.indent(node, options, level) + '<' + node.name;
        // attributes
        if (options.pretty && options.width > 0) {
          len = r.length;
          ref = node.attribs;
          for (name in ref) {
            if (!hasProp.call(ref, name)) continue;
            att = ref[name];
            ratt = this.attribute(att, options, level);
            attLen = ratt.length;
            if (len + attLen > options.width) {
              rline = this.indent(node, options, level + 1) + ratt;
              r += this.endline(node, options, level) + rline;
              len = rline.length;
            } else {
              rline = ' ' + ratt;
              r += rline;
              len += rline.length;
            }
          }
        } else {
          ref1 = node.attribs;
          for (name in ref1) {
            if (!hasProp.call(ref1, name)) continue;
            att = ref1[name];
            r += this.attribute(att, options, level);
          }
        }
        this.stream.write(r);
        childNodeCount = node.children.length;
        firstChildNode = childNodeCount === 0 ? null : node.children[0];
        if (childNodeCount === 0 || node.children.every(function (e) {
          return (e.type === NodeType.Text || e.type === NodeType.Raw || e.type === NodeType.CData) && e.value === '';
        })) {
          // empty element
          if (options.allowEmpty) {
            this.stream.write('>');
            options.state = WriterState.CloseTag;
            this.stream.write('</' + node.name + '>');
          } else {
            options.state = WriterState.CloseTag;
            this.stream.write(options.spaceBeforeSlash + '/>');
          }
        } else if (options.pretty && childNodeCount === 1 && (firstChildNode.type === NodeType.Text || firstChildNode.type === NodeType.Raw || firstChildNode.type === NodeType.CData) && firstChildNode.value != null) {
          // do not indent text-only nodes
          this.stream.write('>');
          options.state = WriterState.InsideTag;
          options.suppressPrettyCount++;
          prettySuppressed = true;
          this.writeChildNode(firstChildNode, options, level + 1);
          options.suppressPrettyCount--;
          prettySuppressed = false;
          options.state = WriterState.CloseTag;
          this.stream.write('</' + node.name + '>');
        } else {
          this.stream.write('>' + this.endline(node, options, level));
          options.state = WriterState.InsideTag;
          ref2 = node.children;
          // inner tags
          for (j = 0, len1 = ref2.length; j < len1; j++) {
            child = ref2[j];
            this.writeChildNode(child, options, level + 1);
          }
          // close tag
          options.state = WriterState.CloseTag;
          this.stream.write(this.indent(node, options, level) + '</' + node.name + '>');
        }
        this.stream.write(this.endline(node, options, level));
        options.state = WriterState.None;
        return this.closeNode(node, options, level);
      }
    }, {
      key: "processingInstruction",
      value: function processingInstruction(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "processingInstruction", this).call(this, node, options, level));
      }
    }, {
      key: "raw",
      value: function raw(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "raw", this).call(this, node, options, level));
      }
    }, {
      key: "text",
      value: function text(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "text", this).call(this, node, options, level));
      }
    }, {
      key: "dtdAttList",
      value: function dtdAttList(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "dtdAttList", this).call(this, node, options, level));
      }
    }, {
      key: "dtdElement",
      value: function dtdElement(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "dtdElement", this).call(this, node, options, level));
      }
    }, {
      key: "dtdEntity",
      value: function dtdEntity(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "dtdEntity", this).call(this, node, options, level));
      }
    }, {
      key: "dtdNotation",
      value: function dtdNotation(node, options, level) {
        return this.stream.write(_get(_getPrototypeOf(XMLStreamWriter.prototype), "dtdNotation", this).call(this, node, options, level));
      }
    }]);
    return XMLStreamWriter;
  }(XMLWriterBase);
}).call(this);